var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcRpm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 255.12 216.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff97cb;}.cls-2{fill:#ffeefa;}.cls-3{fill:#ffdcf3;}.cls-4{fill:#ffd4f2;}.cls-5{fill:#ffccf2;}.cls-6{fill:#ffc5f3;}.cls-7{fill:#ffbdf3;}.cls-8{fill:#ffb0db;}.cls-9{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-rpm") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_10",
    "data-name": 10
  }, /*#__PURE__*/React.createElement("g", {
    id: "alerta_aproximaci\\xF3n"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.12,132.05A126.12,126.12,0,0,1,242,184.18L227.1,176.8a109.5,109.5,0,0,0,11.37-44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M0,132.74a126.17,126.17,0,0,0,13.11,51.43L28,176.8a109.62,109.62,0,0,1-11.4-44.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.94,76.53A110.28,110.28,0,0,0,16.64,122L0,122A126.62,126.62,0,0,1,14.51,68.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M67.57,34.14A111.91,111.91,0,0,0,33.82,68.07L19.76,59.25A128.47,128.47,0,0,1,59.08,19.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M122,16.65A110.26,110.26,0,0,0,76.25,29.09L67.59,14.88A126.74,126.74,0,0,1,122.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M178.86,29.1a110.38,110.38,0,0,0-46.81-12.5L132.39,0a126.65,126.65,0,0,1,54.44,14.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M220.76,67.26a112.09,112.09,0,0,0-34-33.59l8.71-14.13a128.49,128.49,0,0,1,39.85,39.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M238.45,122a110.17,110.17,0,0,0-12.58-46l14.48-8.12A126.58,126.58,0,0,1,255.07,122Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M156.13,182.63a25.86,25.86,0,0,1,1.48,8.09,25.56,25.56,0,1,1-45-16.09l17.72-63.19,20.38,62.39A25.34,25.34,0,0,1,156.13,182.63ZM118.82,196a14.08,14.08,0,0,0,13.53,9.32,14,14,0,0,0,9.37-24.22l-1.05-1-9.47-29L123,180.46l-1,1A14,14,0,0,0,118,191.56,14.36,14.36,0,0,0,118.82,196Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M160.34,92.34h-67A10.09,10.09,0,0,1,83.28,82.26V68.59A10.09,10.09,0,0,1,93.35,58.51h67a10.09,10.09,0,0,1,10.08,10.08V82.26A10.09,10.09,0,0,1,160.34,92.34ZM94.79,80.82H158.9V70H94.79Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcRpm);
export default __webpack_public_path__ + "static/media/ic-rpm.b3d45165926cb7f1173ea1dd57789730.svg";
export { ForwardRef as ReactComponent };